module.exports = __webpack_public_path__ + "img/tyvm-tetsuro.f0dffab9.png";